import { render, staticRenderFns } from "./ImageItem.vue?vue&type=template&id=fd0f8f2a&scoped=true"
import script from "./ImageItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ImageItem.vue?vue&type=style&index=0&id=fd0f8f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0f8f2a",
  null
  
)

export default component.exports